module.exports = __webpack_public_path__ + "img/scene1copy03.97b71e88.png";